<template>
  <section class="about-how-to-use">
    <div class="about-how-to-use__content">
      <AboutPageHeadline
        title="ご利用方法"
        :sub-title="`ギフトとカードデザインを選んで\nURLを送るだけ`"
        color-class="white"
      />
      <div class="about-how-to-use__examples">
        <div class="about-how-to-use__example about-how-to-use__example--1">
          <h3 class="about-how-to-use__example-header">
            <span class="about-how-to-use__number">01</span>
            <p class="about-how-to-use__text">
              <span>相手やシーンに合った</span>
              <span>ギフトを選ぶ</span>
            </p>
          </h3>
          <ImgLazy
            :image-url="HowToUse01"
            alt-text=""
            aspect-ratio="667 / 474"
            image-class="about-how-to-use__example-image"
          />
        </div>
        <div class="about-how-to-use__example about-how-to-use__example--2">
          <h3 class="about-how-to-use__example-header">
            <span class="about-how-to-use__number">02</span>
            <p class="about-how-to-use__text">
              <span>好きなカードデザインを選び</span>
              <span>メッセージを入力</span>
            </p>
          </h3>
          <ImgLazy
            :image-url="HowToUse02"
            alt-text=""
            aspect-ratio="667 / 474"
            image-class="about-how-to-use__example-image"
          />
        </div>
        <div class="about-how-to-use__example about-how-to-use__example--3">
          <h3 class="about-how-to-use__example-header">
            <span class="about-how-to-use__number">03</span>
            <p class="about-how-to-use__text">
              <span>贈りたいギフトを購入</span>
              <span class="about-how-to-use__caption">
                クレジットカード、各種電子決済が使えます
              </span>
            </p>
          </h3>
          <ImgLazy
            :image-url="HowToUse03"
            alt-text=""
            aspect-ratio="667 / 474"
            image-class="about-how-to-use__example-image"
          />
        </div>
        <div class="about-how-to-use__example about-how-to-use__example--4">
          <h3 class="about-how-to-use__example-header">
            <span class="about-how-to-use__number">04</span>
            <p class="about-how-to-use__text">
              <span>表示されたURLを</span>
              <span>相手に送る</span>
            </p>
          </h3>
          <ImgLazy
            :image-url="HowToUse04"
            alt-text=""
            aspect-ratio="667 / 474"
            image-class="about-how-to-use__example-image"
          />
        </div>
        <div class="about-how-to-use__example about-how-to-use__example--5">
          <h3 class="about-how-to-use__example-header">
            <span class="about-how-to-use__number">05</span>
            <p class="about-how-to-use__text">
              <span>受け取った人はURLから、</span>
              <span>ギフトの受け取り手続きを行う</span>
            </p>
          </h3>
          <ImgLazy
            :image-url="HowToUse05"
            alt-text=""
            aspect-ratio="667 / 474"
            image-class="about-how-to-use__example-image"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import ImgLazy from '../../../atoms/images/ImgLazy.vue'
import AboutPageHeadline from '../../../atoms/headlines/AboutPageHeadline.vue'
import HowToUse01 from '../../../../../../images/abouts/how_to_use/01.png'
import HowToUse02 from '../../../../../../images/abouts/how_to_use/02.png'
import HowToUse03 from '../../../../../../images/abouts/how_to_use/03.png'
import HowToUse04 from '../../../../../../images/abouts/how_to_use/04.png'
import HowToUse05 from '../../../../../../images/abouts/how_to_use/05.png'
</script>

<style lang="scss" scoped>
.about-how-to-use {
  background-color: #ffbca0;
  display: flex;
  justify-content: center;

  &__content {
    padding: 96px 72px;
    display: flex;
    flex-direction: column;
    gap: 48px;
    max-width: 1440px;
    width: 100%;

    @media all and (max-width: ($pc-width - 1)) {
      padding: 64px 24px;
      gap: 32px;
    }

    @media all and (max-width: ($base-contents-width - 1)) {
      gap: 24px;
    }
  }

  &__examples {
    background-color: $primary-lighten;
    padding: 64px 24px 64px 72px;
    border-radius: 40px;
    display: grid;
    align-items: end;
    grid-gap: 72px 24px;
    // 各セルのwidthを保ったまま2行目を中央寄せにするために設定
    grid-template-areas:
      'a a b b c c'
      '. d d e e .';

    @media all and (max-width: ($pc-width - 1)) {
      padding: 24px;
      grid-gap: 32px;
      grid-template-areas:
        'a b'
        'c d'
        'e .';
    }

    @media all and (max-width: ($base-contents-width - 1)) {
      grid-template-areas:
        'a'
        'b'
        'c'
        'd'
        'e';
    }
  }

  &__example {
    display: flex;
    flex-direction: column;
    gap: 24px;

    @media all and (max-width: ($pc-width - 1)) {
      gap: 16px;
    }

    &-header {
      display: flex;
      align-items: center;
      gap: 16px;
      height: 62px;

      @media all and (max-width: ($pc-width - 1)) {
        gap: 8px;
      }
    }

    &-image {
      max-width: 100%;
      height: auto;
      object-fit: contain;
    }

    &--1 {
      // grid-template-areas用に設定
      grid-area: a;
    }

    &--2 {
      // grid-template-areas用に設定
      grid-area: b;
    }

    &--3 {
      // grid-template-areas用に設定
      grid-area: c;
    }

    &--4 {
      // grid-template-areas用に設定
      grid-area: d;
    }

    &--5 {
      // grid-template-areas用に設定
      grid-area: e;
    }
  }

  &__number {
    color: #ffbca0;
    font-weight: bold;
    font-size: 5.4rem;
    line-height: 1;
  }

  &__text {
    font-size: 1.8rem;
    line-height: 1.6;
    text-align: left;

    > span {
      display: block;
    }

    @media all and (max-width: ($pc-width - 1)) {
      font-size: 1.6rem;
    }
  }

  &__caption {
    font-size: 1.2rem;
    line-height: 1.6;
    text-align: left;
    color: $gray-1;
    font-weight: normal;
  }
}
:deep(.about-page-headline__sub-title) {
  white-space: normal;

  @media all and (max-width: ($pc-width - 1)) {
    white-space: pre-wrap;
  }
}
</style>
